import React from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { ADGMPanel, ADGMGridLayoutV2 } from 'aurora-components';
import { fPhoneNumber } from 'aurora-utils/utils';

const ApplicationInitiator = ({ application, customTitle, customText, isCompany }) => {
  const { locale: lang } = useSelector(state => state.language);

  const {
    initiatorName,
    initiatorNameAr,
    initiatorEid,
    initiatorEidOrUnified,
    initiatorMobile,
    initiatorMobileNo,
    initiatorEmail,
    initiatorAdminNameAr,
    initiatorAdminNameEn,
    initiatorTradeLicenseNumber,
    initiatorAddress,
    initiatorAddressAr,
    initiatorCompanyNameEn,
    initiatorCompanyNameAr,
  } = application?.applicationDetails ?? application ?? {};
  const isInitiatedByAdmin = !!initiatorAdminNameAr || !!initiatorAdminNameEn;

  function getNameField() {
    if (!isEmpty(customText)) {
      return {
        ar: customText.AR,
        en: customText.EN,
      };
    }

    if (isInitiatedByAdmin) {
      return {
        ar: initiatorAdminNameAr,
        en: initiatorAdminNameEn,
      };
    }

    if (!isInitiatedByAdmin) {
      return {
        ar: initiatorNameAr,
        en: initiatorName,
      };
    }
    return {};
  }

  const initiatorData = isCompany
    ? [
        {
          label: 'Name_English_bracket',
          value: initiatorName ?? '-',
          isPersonName: true,
        },
        {
          label: 'Name_Arabic_bracket',
          value: initiatorNameAr ?? '-',
          isPersonName: true,
        },
        {
          label: 'license_number',
          value: initiatorTradeLicenseNumber ?? '-',
        },
        {
          label: 'company_address',
          value: (lang === 'ar' ? initiatorAddressAr : initiatorAddress) ?? '-',
        },
        {
          label: 'mobile',
          value: fPhoneNumber(initiatorMobileNo || initiatorMobile) ?? '-',
        },
        {
          label: 'email',
          value: initiatorEmail ?? '-',
        },
        ...(initiatorCompanyNameEn || initiatorCompanyNameAr
          ? [
              {
                label: 'initiate_on_behalf_of',
                value: lang === 'ar' ? initiatorCompanyNameAr : initiatorCompanyNameEn,
              },
            ]
          : []),
      ]
    : [
        {
          label: 'Name',
          value: getNameField()[lang] ?? '-',
          isPersonName: true,
        },
        {
          label: 'eid_un',
          value: (initiatorEidOrUnified || initiatorEid) ?? '-',
        },
        {
          label: 'mobile',
          value: fPhoneNumber(initiatorMobileNo || initiatorMobile) ?? '-',
        },
        {
          label: 'email',
          value: initiatorEmail ?? '-',
        },
        ...(initiatorCompanyNameEn || initiatorCompanyNameAr
          ? [
              {
                label: 'initiate_on_behalf_of',
                value: lang === 'ar' ? initiatorCompanyNameAr : initiatorCompanyNameEn,
              },
            ]
          : []),
      ];

  return (
    <ADGMPanel title={customTitle ?? 'initiated_by_text'} hasBodyBorder>
      <ADGMGridLayoutV2 gridData={initiatorData} withIcon gridColumns={4} />
    </ADGMPanel>
  );
};

ApplicationInitiator.propTypes = {
  application: PropTypes.object.isRequired,
  customText: PropTypes.object,
  customTitle: PropTypes.string,
  isCompany: PropTypes.bool,
};
ApplicationInitiator.defaultProps = {
  customText: {},
  isCompany: false,
  customTitle: null,
};
export default ApplicationInitiator;
